"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGit = void 0;
exports.isGit = (value) => new RegExp(/(?:git|ssh|https?|git@[-\w.]+):(\/\/)?(.*?)(\.git)(\/?|\#[-\d\w._]+?)$/).test(value);
//# sourceMappingURL=is-git.js.map